// extracted by mini-css-extract-plugin
module.exports = {"containerStories":"styles_containerStories__TJd48","stories":"styles_stories__LBrGy","imageWrapper":"styles_imageWrapper__mQmQY","image":"styles_image__vcLxA"};